import React, { useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';

import { getMedia } from '../../media-store/mediaStore';
import ImageModal from '../../../components/image-modal/ImageModal';
import SlideButton from '../../../id8/components/frames/slide-button/SlideButton';
import downloadBase64Image from '../../../utils/downloadBase64Image';

import scss from './ResponseItem.module.scss';

function ImageItem({ mediaId }) {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const mediaData = getMedia(mediaId);

  const handleOpenModal = () => {
    setIsOpenModal(true);
  };

  const handleOpenModalByKey = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      setIsOpenModal(true);
    }
  };

  const handleCloseModal = () => {
    setIsOpenModal(false);
  };

  const handleDownload = () => {
    downloadBase64Image(mediaId, mediaData.base64);
  };

  return (
    <div className={scss.imageWrapper}>
      <img
        className={clsx(scss.mediaSizes, scss.image)}
        src={`data:image/png;base64,${mediaData.base64}`}
        alt='Generated'
        onClick={handleOpenModal}
        onKeyDown={handleOpenModalByKey}
        role='presentation'
      />

      <div className={scss.actionButtons}>
        <ActionButtons onDownload={handleDownload} />
      </div>
      <ImageModal
        isOpen={isOpenModal}
        onClose={handleCloseModal}
        imageUrl={`data:image/png;base64,${mediaData.base64}`}
        ActionButtons={<ActionButtons onDownload={handleDownload} />}
      />
    </div>
  );
}

export default ImageItem;

const ActionButtons = ({ onDownload }) => {
  const { t } = useTranslation('scout');

  const handleDownload = () => {
    onDownload();
  };

  return (
    <SlideButton
      icon={DownloadOutlinedIcon}
      onClick={handleDownload}
      ariaLabel='Download this picture'
      tooltip={t('download')}
    />
  );
};
